module.exports = __webpack_public_path__ + "static/media/circle2.65107a64.svg";